// extracted by mini-css-extract-plugin
module.exports = {"frame":"appointment_frame__slTeb"};